import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router, Link } from "@inertiajs/react";
import PlayerForm from "../components/PlayerForm";
import { ChevronLeft } from "lucide-react";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";

export default function PlayerEdit({ player, teamId }: { player: any; teamId: number }) {
    const savePlayer = (data: any) => {
        const requester = new Requester();

        requester
            .post(requester.getUrl(`api/players/${player.id}`), data)
            .then(() => {
                router.visit(`/admin/teams`);
            })
            .catch((error) => {
                alert("Error saving player: " + error.message);
            });
    };

    return (
        <App>
            <PageTitle title="Edit Player" />
            <ContentWrapper>
                <PlayerForm onSubmit={savePlayer} player={player} teamId={teamId} />
            </ContentWrapper>
        </App>
    );
}